module.exports = __webpack_public_path__ + "img/food_institute.d8e2f359.png";